import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import CheckoutTimer from '../components/CheckoutTimer';
import { secondsTohhmmss } from 'helpers/time';

class CheckoutTimerWrapper extends Component {
    getTime = () => {
        return(secondsTohhmmss(this.props.timeRemaining));
    }

    render() {
        return(
            <CheckoutTimer condensed={this.props.condensed !== undefined ? this.props.condensed : false} time={this.getTime()}/>
        )
    }
}

const mapStateToProps = state => {
    return {
        timeRemaining: state.reservation.time_remaining
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

CheckoutTimerWrapper.propTypes = {
    timeRemaining: PropTypes.number.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutTimerWrapper)
